import { render, staticRenderFns } from "./DAPageApp.vue?vue&type=template&id=ca74d566"
import script from "./DAPageApp.vue?vue&type=script&lang=js"
export * from "./DAPageApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports